import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { parseISO } from 'date-fns';

import { formatDate } from '@spa/shared/utils/date';
import { Wrapper, Column } from './styles';

const DATE_FORMAT = 'MMMM yyyy';

const Description = ({ accommodationOffer }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const { requisites, availabilities, availability_summary_info } = accommodationOffer;
  const minimumStayDays =
    Math.max(
      requisites?.conditions?.minimum_nights || 0,
      availabilities?.availability_rules?.[0]?.gap?.move_in_out?.items?.[0]?.end?.min?.days || 0
    ) ?? 'N/A';
  const maximumStayDays = availabilities?.availability_rules?.[0]?.gap?.move_in_out?.items?.[0]?.end?.max?.days ?? null;
  const lastUpdated =
    availability_summary_info?.fixed_contract?.last_updated_at ||
    availability_summary_info?.standard_contract?.last_updated_at ||
    availability_summary_info?.standard_unitary_contract?.last_updated_at;

  const getAvailableFrom = () => {
    const { standard_unitary, standard } = availabilities ?? {};

    const standardUnitaryStartDate = standard_unitary?.available_periods?.[0]?.start_date;
    const standardStartDate = standard?.available_periods?.[0]?.start_date;

    return parseISO(standardUnitaryStartDate || standardStartDate || new Date().toISOString());
  };

  return (
    <Wrapper>
      <Column>
        <p>
          <span>{t('Available from')}</span> {formatDate(getAvailableFrom(), language, DATE_FORMAT)}
        </p>
        <p>
          <span>{t('Min stay')}</span> {minimumStayDays} {t('nights')}
        </p>
        <p>
          <span>{t('Max stay')}</span> {maximumStayDays ? `${maximumStayDays} ${t('nights')}` : t('No maximum stay')}
        </p>
      </Column>
      <Column>
        <p>
          <span>{t('Last updated')}</span> {lastUpdated ? formatDate(lastUpdated, language, DATE_FORMAT) : 'N/A'}
        </p>
      </Column>
    </Wrapper>
  );
};

Description.propTypes = {
  accommodationOffer: PropTypes.object.isRequired
};

export default Description;
